import type { WrittenPage } from '../../sections'

/**
 * "Top 5 AI Success Strategies" e-kitabı — Türkçe.
 *
 * Bölüm sırası, görseller ve maddeler İngilizcesiyle birebir aynı; değişen
 * yalnızca nasıl söylendiği. E-kitabın adı çevrilmiyor — kapağında basılı olan
 * lettering o; "governance", "machine learning", "NLP", "computer vision" gibi
 * yerleşik terimler de İngilizce kalıyor.
 *
 * İndirilen dosya İngilizce — e-kitabın Türkçesi yok. Bu, sayfayı Türkçe
 * yazmamak için bir sebep değil: sayfayı okuyup indirme kararını veren kişi
 * Türkiye'deki okur, ve karar Türkçe veriliyor.
 *
 * Formla ilgili açık soru İngilizce sayfada duruyor ve orada bir kez duruyor:
 * `check` iki dilde tekrarlanınca aynı karar iki not olarak sayılıyor.
 */
/** İngilizce sayfadaki dosyanın aynısı — e-kitabın Türkçesi yok. */
const PDF
  = 'https://njdxtkezxgkrmwwhzcne.supabase.co/storage/v1/object/public/website-documents/ebook/'
  + '6b09bdf8-a5f9-432b-81c4-100ffd11e0d8-digitopia-report-top5ai-r2.pdf'

export const ebookTop5AiSuccessStrategies: WrittenPage = {
  navLabel: 'Top 5 AI Success Strategies',
  title: 'Top 5 AI Success Strategies',
  description:
    'AI’ın gücünden yararlanmanız için uygulanabilir içgörüler ve gerçek dünyadan örnekler: müşteri deneyimini yükseltin, operasyonu sadeleştirin, inovasyonu hızlandırın. Digitopia Impact Labs’in e-kitabını indirin.',
  sections: [
    {
      kind: 'hero',
      eyebrow: 'AI’ın tüm potansiyelini açığa çıkarın',
      headline: 'Top 5 AI Success Strategies',
      body: [
        'İşinizi AI ile dönüştürmeye hazır mısınız? Kapsamlı e-kitabımız, AI’ın gücünden '
          + 'yararlanmanız için uygulanabilir içgörüler ve gerçek dünyadan vaka çalışmaları '
          + 'sunuyor. Müşteri deneyimini nasıl yükselteceğinizi, operasyonu nasıl '
          + 'sadeleştireceğinizi ve inovasyonu nasıl hızlandıracağınızı öğrenin.',
      ],
      ctas: [{ label: 'İndirin', href: PDF }],
      photo: {
        src: '/photo/top5-ai-ebook-artwork.webp',
        alt:
          'E-kitabın kapak görseli: yukarıdan görünen, cadde ve kuleleri mavi ile mor ışıkla '
          + 'aydınlanmış gece şehri ve üzerinde yükselen ışık noktaları.',
      },
      photoFrame: 'square',
    },
    {
      kind: 'cta',
      tone: 'card',
      flip: true,
      heading: 'Neden indirmelisiniz?',
      points: [
        'Uygulanabilir içgörüler: AI’ı kişiselleştirilmiş müşteri etkileşimleri, optimize '
          + 'edilmiş operasyon ve dahası için nasıl kullanacağınızı anlayın.',
        'Gerçek dünyadan örnekler: Netflix, General Electric ve Google gibi önde giden '
          + 'şirketlerin öne geçmek için AI’ı nasıl kullandığını görün.',
        'Eyleme dönük stratejiler: AI yetkinliği kurmak, ileri teknolojileri benimsemek ve etik '
          + 'bir AI kullanımını güvence altına almak için adım adım yol alın.',
      ],
      ctas: [{ label: 'E-kitabı indirin', href: PDF }],
      photo: {
        src: '/photo/top5-ai-ebook-covers.webp',
        alt:
          'Top 5 AI Success Strategies’in iki kopyası, biri diğerinin arkasında, beyaz bir '
          + 'zeminde.',
      },
    },
    {
      kind: 'cta',
      tone: 'card',
      heading: 'Neler öğreneceksiniz?',
      points: [
        'Müşteri deneyimini yükseltin: Etkileşimleri kişiselleştirmek ve memnuniyeti artırmak '
          + 'için AI’ı kullanın.',
        'Operasyonu sadeleştirin: Süreçleri AI destekli otomasyon ve predictive maintenance ile '
          + 'optimize edin.',
        'Ekibinizi güçlendirin: AI becerilerini geliştirin ve bir inovasyon kültürü kurun.',
        'İleri AI teknolojilerini benimseyin: Machine learning, NLP ve computer vision’ı hayata '
          + 'geçirin.',
        'Etkili bir AI governance kurun: Sorumlu ve etik bir AI kullanımını güvence altına alın.',
      ],
      ctas: [{ label: 'E-kitabı indirin', href: PDF }],
      photo: {
        src: '/photo/top5-ai-ebook-stack.webp',
        alt: 'Yukarıdan görünen, üst üste dizilmiş Top 5 AI Success Strategies kopyaları.',
      },
    },
    {
      kind: 'prose',
      heading: 'Bize ulaşın',
      sub:
        'Bu beş stratejiyi kendi kurumunuzda nasıl işleteceğinizi konuşalım; AI hedefinizi '
        + 'ölçülebilir sonuçlara çevirmenize yardımcı oluyoruz.',
      cta: { label: 'Bize Ulaşın', href: '#contact' },
    },
    {
      kind: 'prose',
      align: 'center',
      heading: 'Ücretsiz e-kitabınızı şimdi indirin!',
      sub:
        'Uzman içgörülerimiz ve stratejilerimizle işinizi dönüştürün, rekabette önde kalın. '
        + 'Kaçırmayın!',
      cta: { label: 'E-kitabı indirin', href: PDF },
    },
  ],
}
